<template>
    <div>
        <h1 class="mb-4"><v-icon color="primary">mdi-account-edit</v-icon> Editar Usuario</h1>
        <v-progress-linear :active="cargando" :indeterminate="cargando" absolute top color="primary" />
        <form-usuario :usuario="usuario" :es-edicion="true" @registrado="onRegistrado" />
        <v-snackbar v-model="mostrarMensaje" :timeout="3000" :color="mensaje.color" top>
            {{ mensaje.texto }}
        </v-snackbar>
    </div>
</template>

<script>
import HttpService from '../../Servicios/HttpService'
import FormUsuario from './FormUsuario.vue'

export default {
    name: 'EditarUsuario',
    components: { FormUsuario },

    data: () => ({
        cargando: false,
        usuario: { usuario: '', nombre: '', telefono: '', rol: 'recepcionista' },
        mostrarMensaje: false,
        mensaje: { texto: '', color: '' },
    }),

    mounted() {
        this.cargando = true
        HttpService.obtenerConDatos({ metodo: 'un_usuario', id: this.$route.params.id }, 'usuarios.php')
        .then(resultado => {
            if (resultado) this.usuario = resultado
            this.cargando = false
        })
    },

    methods: {
        onRegistrado(usuario) {
            this.cargando = true
            HttpService.registrar({ metodo: 'put', usuario }, 'usuarios.php')
            .then(resultado => {
                if (resultado) {
                    this.mostrarMensaje = true
                    this.mensaje = { texto: 'Usuario actualizado correctamente', color: 'success' }
                    this.cargando = false
                    setTimeout(() => this.$router.push({ name: 'Usuarios' }), 1000)
                }
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Usuarios/EditarUsuario.vue